import browserUpdate from 'browser-update';
import objectFitImages from 'object-fit-images';
import smoothScroll from 'smooth-scroll';
import carbonConfig from './carbon-configs';

// Using our own copy of focus-within polyfill because the
// original one doesn't come pre-complied
// https://github.com/jonathantneal/focus-within
import focusWithin from './js/polyfills/focus-within';
import MobileNav from './js/mobile-nav';
import inPageNav from './js/inpage-nav';
import CustomDropdown from './js/custom-dropdown';
import ResourcesFilter from './js/resources-filter';
import MobileNavToggles from './js/mobile-nav-toggles';
import ExternalLinks from './js/externalLinks';
import searchForm from './js/search-form';
import './js/element-carousel';
import watchCustomMax from './js/custom-max-width';
import AdjustFloatingBox from './js/floating-box';
import inContnetFullWidth from './js/incontent-fullwidth';
import MasonryGrid from './js/masonrygrid';
import ResponsiveTables from './js/responsive-tables';
import { Accordion, Dropdown, Tooltip } from 'carbon-components';
import AccordionElement from './js/element-accordion';
import Quiz from './js/quiz';
import ElementProfiles from './js/element-profiles';

import './js/polyfills';
import './js/primary-nav';
import './js/detect-browser';
import ParsleyInit from './js/parsley-init';

// Doing it this way ensures that the rendered CSS is correct. Don’t try to import the SCSS file into another SCSS file unless you want to do major work on relative paths – it’s messy.
// https://shellmonger.com/2016/01/22/working-with-fonts-with-webpack/
import './static/fonts/opensans.scss';
import './static/fonts/national2.scss';
import './scss/styles.scss';

// missing forEach on NodeList for IE11
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

const init = () => {
  browserUpdate();
  objectFitImages();
  watchCustomMax();
  AdjustFloatingBox('offsetbanner');
  AdjustFloatingBox('linkcollectionbanner', 64);
  inContnetFullWidth();
  MasonryGrid('.listgrid', '.listgrid-item', '.post-summary');
  CustomDropdown.init();
  ResourcesFilter.init();
  smoothScroll('a[href*="#"]');
  ExternalLinks();
  ResponsiveTables();
  focusWithin(document, {
    force: true
  });
  inPageNav();
  MobileNav.init();
  MobileNavToggles.init();
  ParsleyInit();
  Accordion.init(document, carbonConfig.accordion);
  Dropdown.init(document, carbonConfig.dropdown);
  AccordionElement();
  Quiz();
  ElementProfiles();
  const tooltipTriggers = document.querySelectorAll('[data-tooltip-trigger]');

  tooltipTriggers.forEach(tooltip => {
    Tooltip.create(tooltip, {
      classShown: 'nzr--tooltip--shown'
    });
  });

  searchForm.init();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
